import { createListenerMiddleware } from '@reduxjs/toolkit';

/**
 *
 * A conventional way of creating an application's
 * `ListenerMiddlewareInstance` and initializing
 * the listener functions that have been defined.
 * @param listeners a flat array of `ApplyListenerFunction`s
 * @returns ListenerMiddlewareInstance
 *
 */

// PM does not pass an extra arg at this time,
// but that is possible. For now we pass an empty object.
export var initStoreListeners = function initStoreListeners(listeners) {
  var listenerMiddleware = createListenerMiddleware();
  listeners.forEach(function (init) {
    return init(listenerMiddleware);
  });
  return listenerMiddleware;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/initStoreListeners.js
// module id = 4533
// module chunks = 11